export default "__VITE_ASSET__8a86b08d__"